// src/components/Onboarding/LikeDislikeButton.js
import React from 'react';
import { useTintableSvg } from '../../utils/Onboarding/tintableSvg';
import likeIcon from '../../images/optionIcons/likeIcon.svg';
import dislikeIcon from '../../images/optionIcons/dislikeIcon.svg';

export default function LikeDislikeButton({
  variant = 'like',         // 'like' | 'dislike'
  onClick,
  theme = 'dark',
  className = '',
  children,
}) {
  const isLike = variant === 'like';
  const label = children || (isLike ? 'Like' : 'Dislike');
  const iconSrc = isLike ? likeIcon : dislikeIcon;

  // Theme-aware base styles (unchanged)
  const base = `inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full md:rounded-xl border transition focus:outline-none focus:ring-2 focus:ring-offset-2 ${
    theme === 'dark'
      ? 'text-white border-gray-600 hover:bg-gray-800 focus:ring-gray-500 focus:ring-offset-mm_black'
      : 'text-mm_black border-gray-300 hover:bg-gray-100 focus:ring-gray-400 focus:ring-offset-white'
  }`;

  const isSvg = typeof iconSrc === 'string' && iconSrc.toLowerCase().endsWith('.svg');

  const tintableMarkup = useTintableSvg(isSvg ? iconSrc : null);

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${base} ${className}`}
      aria-label={label}
    >
      {/* SVG variant inherits currentColor */}
      {isSvg ? (
        tintableMarkup ? (
          <span
            aria-hidden="true"
            className="h-4 w-4 inline-block shrink-0"
            style={{ color: 'currentColor' }}
            dangerouslySetInnerHTML={{ __html: tintableMarkup }}
          />
        ) : (
          <span
            aria-hidden="true"
            className="h-4 w-4 inline-block shrink-0"
            style={{
              color: 'currentColor',
              backgroundColor: 'currentColor',
              WebkitMaskImage: `url(${iconSrc})`,
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              WebkitMaskSize: 'contain',
              maskImage: `url(${iconSrc})`,
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              maskSize: 'contain',
            }}
          />
        )
      ) : (
        <img
          src={iconSrc}
          alt=""
          aria-hidden="true"
          className="h-5 w-5"
          // Fallback for non-SVGs: force black
          style={{ filter: 'brightness(0) saturate(100%)' }}
          loading="lazy"
        />
      )}

      <span className="text-sm font-medium">{label}</span>
    </button>
  );
}
